import { IsString, MaxLength, IsOptional, IsArray, MinLength } from "class-validator";

export class ProductVersionSearchDTO {
    
    @IsOptional()
    @IsString()
    @MaxLength(50)
    version: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    description: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    products: Array<string>;

}
